import { AuthProviderEnum, UserInterface } from '@sport-activities/sdk';
import { parseISO } from 'date-fns';

import { GenderEnum } from '~/auth/enum/gender.enum';

export class User implements UserInterface {
  public birthdate?: string;
  public country?: string;
  public email: string;
  public familyName: string;
  public gender?: GenderEnum;
  public givenName: string;
  public identifier: string;
  public phoneNumber?: string;
  public providerIdentifier?: string;
  public providerName?: AuthProviderEnum;

  constructor(user?: Partial<User>) {
    Object.assign(this, user);
  }

  public get fullname(): string | null {
    const fullname = [this.givenName?.trim(), this.familyName?.trim()]
      .join(' ')
      .trim();

    return fullname || null;
  }

  public get initials(): string {
    let initialsString = '';

    if (this.givenName && this.familyName) {
      initialsString = this.givenName[0] + this.familyName[0];
    }

    return initialsString;
  }

  /** get birthdate as date */
  public getBirthdate(): Date {
    if (!this.birthdate) {
      return;
    }

    return parseISO(this.birthdate);
  }

  public isProfileComplete(): boolean {
    return (
      !!this.givenName && !!this.familyName && !!this.birthdate && !!this.gender
    );
  }
}
